import { TRACK_PAGE_TYPE } from '../domains/PageTypes'
import { getPageContextDetails } from './getPageContextDetails'

export const getIsHomePage = () => {
  const { currentPage } = getPageContextDetails()
  return currentPage.page_type === TRACK_PAGE_TYPE.HOME
}
